export default __webpack_public_path__ + "static/media/csdBan.6354f325.png";